import { fas } from "@fortawesome/free-solid-svg-icons";
import React, { Component } from "react";
import { getListValues } from "../../../../services/listService";

class PicklistViewer extends Component {
  state = {
    Question_ID: this.props.Question_ID,
    List_ID: parseInt(this.props.Question_Answers[0].Answer_Text),
    List_Values: [],
    Answer_ID: this.props.Answer_ID ? this.props.Answer_ID : 0,
    Response_Required: this.props.Response_Required,
    preloadQAData: this.props.preloadQAData ? this.props.preloadQAData : {},
    selectedInst : this.props.selectedInst ? this.props.selectedInst : '',
    Custom_Render: this.props.Custom_Render ? this.props.Custom_Render : null,
    loading: true,
  };

  async componentDidMount() {
    //Custom Rendering List
    let List_ID = undefined;
    let default_ListID = parseInt(this.props.Question_Answers[0].Answer_Text);
    let institutionId = this.props.selectedInst;
    let filterByInstitution = false;

    if (this.state.Custom_Render !== null) {
      let Custom_Render = this.state.Custom_Render, conditions = [];
      this.state.Custom_Render.split('\n').forEach(function (line, lineIdx) {
        if (line.includes('IF')) {
          conditions.push({
            'condition': line.split(' ')[1],
            'action_ID': parseInt(Custom_Render.split('\n')[lineIdx + 1].split('=')[1]),
            'result':
                line.split(' ')[1].toLowerCase().includes('institution') &&
                (institutionId === line.split(' ')[1].split('=')[1])
          })
        }
        else if (line.includes('FILTER BY @Institution_ID')) {
          filterByInstitution = true;
        }
      });

      if (conditions.length > 0 && conditions.some((c) => c.result)) {
        List_ID = parseInt(conditions.filter((c) => c.result)[0].action_ID);
      }
      else {
        List_ID = parseInt(default_ListID ?? this.props.Question_Answers[0]?.Answer_Text)
      }
      this.setState({ default_ListID, conditions });
    }

    let { data: List_Values } = await getListValues(
        List_ID ? List_ID : default_ListID,
        filterByInstitution ? parseInt(institutionId) : 0,
        this.props.PrimaryKey
    );

    this.setState({ List_Values });
    this.handleSelection({ target: { value: this.state.preloadQAData.Answer_ID } });
    this.setState({ loading: false });
  }

  handleSelection = ({ target }) => {
    let List_Value_ID = parseInt(target.value);
    let selected = this.state.List_Values.filter(
      (lv) => lv.List_Value_ID === List_Value_ID
    )[0];

    this.props.OnUpdate(this.props.Question_Number, 
      {
        Responses: 
        List_Value_ID === -1 ? [] : [
          {
            Question_Number:this.props.Question_Number,
            Question_ID: this.state.Question_ID,
            Answer_ID: List_Value_ID || null,
            Answer_Text: (selected) ? selected.Value_ID + ":" + selected.Value_Text : null,
          },
        ],
        Response_Required: this.state.Response_Required,
      }
    );
    this.setState({ Answer_ID: List_Value_ID });
  };

  render() {

    if (this.state.loading) return <div className="center">Loading...</div>;

    const { Question_ID, List_Values, Answer_ID } = this.state;
    return (
      <div className="form-group" key={"Q" + Question_ID}>
        <select
          className="form-control"
          onChange={this.handleSelection}
          value={Answer_ID.toString()}
          disabled={this.props.disabled}
        >
          <option key={"ans" + Question_ID + "default"} value="-1">
            - Select -
          </option>
          {List_Values.map((lv) => (
            <option key={"lv" + lv.List_Value_ID} value={lv.List_Value_ID}>
              {lv.Value_Text}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default PicklistViewer;
